module.exports = __webpack_public_path__ + "static/bv-1-9bf00c8c316cf6b3c24bee20fe67dfad.jpg";